module.exports = __webpack_public_path__ + "static/media/loading20.c57e6ed0.png";


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/index/img/loading/loading20.png
// module id = 205
// module chunks = 0